import React from "react";

const ContactBanner = ({handleOnClick}) => {
  return (
    <div id="contact-us-banner-container">
      <div id="contact-us-banner">
        <div>
          <h1 className="contact-title">Get In Touch</h1>
          <div className="contact-desc-title">
            Let’s Build Something Extraordinary Together
          </div>
          <p className="contact-desc-message">
            Whether you’re exploring startup ideas, tackling challenges, or
            scaling your business, we’re here to help.
          </p>
          <div>
            <button className="btn" onClick={handleOnClick}>Free Evaluation Now</button>
          </div>
        </div>
        <div>
          <img src="/contactbanner.svg" alt="conact-banner" />
        </div>
      </div>
    </div>
  );
};

export default ContactBanner;
